import { render, staticRenderFns } from "./orderStatusTable.vue?vue&type=template&id=c9348440&scoped=true&"
import script from "./orderStatusTable.vue?vue&type=script&lang=js&"
export * from "./orderStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./orderStatusTable.vue?vue&type=style&index=0&id=c9348440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9348440",
  null
  
)

export default component.exports